import { Component, Input } from '@angular/core';
import { Icon } from '@psei/ng/api';
import { BehaviorSubject } from 'rxjs';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'ppb-lang-select',
  templateUrl: './ppb-lang-select.component.html',
  styleUrls: ['./ppb-lang-select.component.scss']
})
export class PpbLangSelectComponent {
  @Input() loginPage: boolean = false

  readonly langIcon = Icon.create('globe');
  readonly langItems = LanguageService.langItems;

  langIsActive = false;
  selectedLanguage$: BehaviorSubject<string>;

  constructor(
    private languageService: LanguageService,
  ) {
    this.selectedLanguage$ = this.languageService.selectedLanguage$;
  }

  handleLangChange(lang: unknown): void {
    this.languageService.handleLanguageChange(lang as string, this.loginPage);
  }
}
